import React from 'react';

import { Stack, Typography } from '@gogame/components';
import { ScreenGo } from '@gogame/screens';

import * as CONCEPT from 'scenes/Gallery/GalleryPage/Concepts/view-constants';
import * as CREATIVE from 'scenes/Gallery/GalleryPage/Creatives/view-constants';
import {
  AttributeItem,
  AttributeList,
} from 'scenes/Gallery/components/AttributeList';
import { PreviewFile } from 'scenes/Gallery/components/File';
import {
  THUMBNAIL_URL,
  VIDEO_LENGTH,
} from 'scenes/Gallery/components/File/constants';
import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';

const DetailsFile = ({ data }) => {
  const { isAllowSharedWith, isAllowExclusiveForAffiliates } =
    useGalleryPermissions();

  const {
    [CONCEPT.ID]: conceptId,
    [CONCEPT.NAME]: conceptName,
    [CONCEPT.CREATIVES_COUNT]: creativesCount,
    [CONCEPT.ORIGINAL]: {
      [CREATIVE.ID]: creativeId,
      [CREATIVE.CREATIVE_TYPE]: originalCreativeType,
      [CREATIVE.AI_GENERATED]: originalAIGenerated,
      [CREATIVE.FILE]: {
        [THUMBNAIL_URL]: originalFileThumbnailURL,
        [VIDEO_LENGTH]: originalFileVideoLength,
      } = {},
    } = {},
    [CONCEPT.EXCLUSIVE_FOR_AFFILIATES]: exclusiveForAffiliates,
    [CONCEPT.IS_NEW]: isNew,
    [CONCEPT.IS_PARTIAL_SHARED]: isPartialShared,
    [CONCEPT.IS_SHARED]: isShared,
    [CONCEPT.IS_THUMBNAIL_GENERATING]: isThumbnailGenerating,
    [CONCEPT.EXPIRATION_DATE]: expirationDate,
  } = data;

  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      spacing={3}
      zeroMinWidth={true}
    >
      <ScreenGo to={`${creativeId}`} data-cy={`Creative Details`}>
        <PreviewFile
          src={originalFileThumbnailURL}
          thumbnail={isThumbnailGenerating}
          width={132}
          height={70}
          attributes={
            <AttributeList
              justifyContent={'space-between'}
              direction={'row-reverse'}
              color={'common.white'}
              spacing={0.5}
              p={0.5}
            >
              {originalFileVideoLength ? (
                <AttributeItem
                  valueParser={'fileVideoLength'}
                  value={originalFileVideoLength}
                />
              ) : null}
            </AttributeList>
          }
        />
      </ScreenGo>
      <Stack zeroMinWidth={true}>
        <Typography variant={'caption'} color={'textSecondary'}>
          {`Concept #${conceptId}`}
        </Typography>
        <Typography variant={'h6'} noWrap={true}>
          {conceptName}
        </Typography>
        <Stack spacing={1} direction={'row'}>
          <AttributeList type={'text'} listSeparator={'|'}>
            <AttributeItem
              valueParser={'variantsCount'}
              value={creativesCount}
            />
            <AttributeItem
              valueParser={'creativeType'}
              value={originalCreativeType}
            />
          </AttributeList>
          <AttributeList type={'icon'}>
            {exclusiveForAffiliates.length && isAllowExclusiveForAffiliates ? (
              <AttributeItem valueParser={'exclusiveForAffiliates'} />
            ) : null}
            {originalAIGenerated ? (
              <AttributeItem valueParser={'aiGenerated'} />
            ) : null}
            {expirationDate ? (
              <AttributeItem
                value={expirationDate}
                valueParser={'expirationDate'}
              />
            ) : null}
            {isPartialShared && isAllowSharedWith ? (
              <AttributeItem
                key={'partialShared'}
                valueParser={'partialShared'}
              />
            ) : isShared && isAllowSharedWith ? (
              <AttributeItem key={'shared'} valueParser={'shared'} />
            ) : null}
            {isNew ? <AttributeItem valueParser={'new'} /> : null}
          </AttributeList>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default DetailsFile;
